<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" *ngIf="editable" (click)="submit()">Zapisz</button>
	<button
		class="btn btn-primary me-3"
		*ngIf="!editable && state === 'primaryData'"
		(click)="setDefaultTab()"
		(click)="editUnlock()"
	>
		Edycja
	</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<mat-tab-group
		animationDuration="0ms"
		mat-stretch-tabs="false"
		mat-align-tabs="start"
		[selectedIndex]="selectedTab.value"
		(selectedIndexChange)="selectedTab.setValue($event)"
	>
		<mat-tab label="Dane podstawowe">
			<div class="my-4">
				<app-group-offer-basic
					[data]="data"
					[products]="products"
					[locations]="locations"
					[editable]="editable"
					[dateRange]="dateRange"
				>
				</app-group-offer-basic></div
		></mat-tab>

		<mat-tab [disabled]="editable">
			<ng-template mat-tab-label>
				<span *ngIf="editable" matTooltip="Aby edytować terminy zapisz dane podstawowe">Terminy</span>
				<span *ngIf="!editable">Terminy</span>
			</ng-template>
			<div class="my-4">
				<app-group-offer-terms
					[data]="data"
					[groupProducts]="data.groupProducts"
					[products]="products"
					[editable]="editable"
					(afterGenerate)="loadData()"
				>
				</app-group-offer-terms></div
		></mat-tab>
		<mat-tab [disabled]="editable"
			><ng-template mat-tab-label>
				<span *ngIf="editable" matTooltip="Aby edytować cenniki zapisz dane podstawowe">Cenniki</span>
				<span *ngIf="!editable">Cenniki</span>
			</ng-template>
			<div class="my-4">
				<app-group-offer-price
					[id]="data.id"
					[groupPriceSetting]="priceSetting"
					[offerTerm]="groupOfferTerm"
					[displayedProducts]="productsForFilters"
					[board]="board"
					[editable]="editable"
				></app-group-offer-price></div
		></mat-tab>
		<mat-tab [disabled]="editable"
			><ng-template mat-tab-label>
				<span *ngIf="editable" matTooltip="Aby edytować ustawienia wspólne zapisz dane podstawowe"
					>Ustawiania wspólne dla cenników</span
				>
				<span *ngIf="!editable">Ustawiania wspólne dla cenników</span>
			</ng-template>
			<div class="my-4">
				<h5 class="my-4 fw-bold">Ustawienia globalne</h5>
				<app-group-offer-price-setting
					[currency]="currency"
					[board]="board"
					[data]="data"
					[priceSetting]="priceSetting"
					[priceOption]="priceOption"
					[editable]="editable"
					(afterGenerate)="loadData()"
				></app-group-offer-price-setting></div
		></mat-tab>
	</mat-tab-group>
</div>
